import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/store',
	name: 'store',
	meta,
	redirect: {
		name: 'store-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'storeList',
			name: `${pre}list`,
			component: _import('store/storeList'),
			meta: {
				...meta,
				title: '驿站列表'
			}
		},
		{
			path: 'couponList',
			name: `${pre}couponList`,
			component: _import('store/couponList'),
			meta: {
				...meta,
				title: '商家券列表'
			}
		},
	])('store-')
}